import { useT } from "../../i18n";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { Phrases } from "../Phrases";

export const WhySection = ({ index = "04" }) => {
  const t = useT();
  const items = t("why.items");
  return (
    <section data-testid="why-section" className="bg-white py-24 text-ink sm:py-32 lg:py-40">
      <div className="container-x">
        <SectionHeading index={index} eyebrow={t("why.eyebrow")} title={<Phrases text={t("why.title")} />} testId="why-heading" className="max-w-4xl" />
        <div className="mt-16 grid gap-0 md:grid-cols-3 lg:mt-24">
          {items.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.12} className="border-t border-ink/15 py-10 md:border-l md:border-t-0 md:px-8 md:py-2 md:first:border-l-0 md:first:pl-0 lg:px-12">
              <div data-testid={`why-item-${i + 1}`}>
                <span className="font-display text-5xl leading-none text-ink/25 lg:text-6xl">0{i + 1}</span>
                <h3 className="why-title mt-8 text-lg font-medium lg:mt-12">{item.title}</h3>
                <p className="mt-3 max-w-xs text-sm text-ink/60">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
